<template>
	<nav class="bg-green-600">
		<!-- #todo define meaningful max width -->
		<div class="NOTmax-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
			<div class="flex items-center justify-between h-16">
				<div class="flex items-center">
					<!-- logo -->
					<div class="flex-shrink-0 flex">
						<page-link href="/">
							<ui-icon
								class="h-12 w-12 flex-shrink-0"
								name="logo"
								fill="#ffffff"
							/>
						</page-link>
					</div>

					<div class="hidden md:block">
						<layout-admin-top-nav-items />
					</div>
				</div>

				<div class="hidden md:block">
					<div class="ml-4 flex items-center md:ml-6">
						<ui-dropdown
							button-class="flex text-white hover:bg-green-500 active:bg-green-700 focus:bg-green-700 px-3 py-2 rounded-md text-sm font-medium"
						>
							<template v-slot:button>
								<span class="sr-only">Open dropdown</span>
								{{ user.email }}
								<ui-icon
									class="ml-2 -mr-1 flex-shrink-0 h-5 w-5"
									name="chevron-down"
									stroke-width="1.5"
								/>
							</template>

							<template v-slot:items>
								<inertia-link
									:href="$route('logout')"
									method="post"
									as="button"
									class="block px-4 py-2 text-gray-700"
									role="menuitem"
									tabindex="-1"
									id="user-menu-item-2"
									>{{ __("Logout") }}</inertia-link
								>
							</template>
						</ui-dropdown>
					</div>
				</div>

				<!-- Mobile menu button -->
				<div class="flex md:hidden">
					<button
						type="button"
						v-on:click.stop="showMobileNav = !showMobileNav"
						class="bg-green-600 inline-flex items-center justify-center p-2 rounded-md text-green-200 hover:text-white focus:bg-green-700 hover:bg-green-500 hover:bg-opacity-75 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-green-600 focus:ring-white"
						aria-controls="mobile-menu"
						aria-expanded="false"
					>
						<span class="sr-only">Open main menu</span>
						<ui-icon
							class="block h-6 w-6 text-white"
							:name="showMobileNav ? 'x' : 'menu'"
							stroke-width="1.5"
						/>
					</button>
				</div>
			</div>
		</div>

		<!-- Mobile menu, show/hide based on menu state. -->
		<div class="md:hidden" id="mobile-menu" v-if="showMobileNav">
			<layout-admin-top-nav-items-mobile />

			<div class="pt-4 pb-3 border-t border-green-700">
				<div class="flex items-center px-5">
					<div>
						<div class="text-base font-medium text-white">
							{{ user.company_name }}
						</div>
						<div class="text-sm font-medium text-green-300">
							{{ user.email }}
						</div>
					</div>
					<!-- logout ?? -->
					<button
						type="button"
						class="ml-auto bg-green-600 flex-shrink-0 p-1 rounded-full text-green-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-green-600 focus:ring-white"
					>
						<span class="sr-only">Logout</span>
						<ui-icon
							class="block h-6 w-6 text-white"
							name="log-out"
							stroke-width="1.5"
						/>
					</button>
				</div>
				<!-- user menu -->
				<div class="mt-3 px-2 space-y-1">
					<inertia-link
						:href="$route('logout')"
						method="post"
						as="button"
						class="block px-3 py-2 rounded-md text-base font-medium text-white hover:bg-green-500 hover:bg-opacity-75"
						role="menuitem"
						tabindex="-1"
						id="user-menu-item-2"
						>{{ __("Logout") }}</inertia-link
					>
				</div>
			</div>
		</div>
	</nav>
</template>

<script>
export default {
	props: {},
	data() {
		return {
			showMobileNav: false,
			user: this.$inertia.page.props.user,
		};
	},
};
</script>
